import React from "react";
var __jsx = React.createElement;
import stl from "./CarCardsGroup.module.css";
import Spacing from "@/_LayoutsRelated/spacing/Spacing";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var CarCardsGroup = function CarCardsGroup(props) {
  var _props$products, _props$cta;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.SuggestionsContainerOnline
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.revampedHome].join(" ")
  }, /*#__PURE__*/React.createElement(props.headingType, {
    className: [stl.revampedTitle].join(" ")
  }, props.title), /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.allCarsResult, stl.allCarsResultRevamped].join(" ")
  }, (_props$products = props.products) === null || _props$products === void 0 ? void 0 : _props$products.map(function (post, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: post.id,
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      titleTag: "h3"
    }));
  }))), /*#__PURE__*/React.createElement("a", {
    href: props.url,
    className: [["margin-auto", "redBtn", "moreSameCar", stl.showMorwBtn].join(" ")].join(" ")
  }, props === null || props === void 0 ? void 0 : (_props$cta = props.cta) === null || _props$cta === void 0 ? void 0 : _props$cta.text))));
};
export default CarCardsGroup;